import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";

export interface General {
  id: number;
  title: string;
  field_title_general_en: string;
  field_title_general_ms: string;
  field_title_general_zh: string;
  field_description_general_en: string;
  field_description_general_ms: string;
  field_general_description_zh: string;
  field_circular_date: string;
  field_created_circular_date: string;
  field_page_published_circular: boolean;
  field_updated_circular_date: string;
}

export interface Circular {
  id: number;
  title: string;
  field_title_eng: string;
  field_title_mal: string;
  field_title_man: string;
  field_pdfurl: string;
  field_date: string;
  field_description_eng: string;
  field_description_mal: string;
  field_description_man: string;
  field_circular_published: boolean;
  field_circular_page_date: string;
  field_circular_page_updated_date: string;
}

const fetchDetails = async (id: string, api: any): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await magpCMSApi.get(api);
  return response.data[0];
};

const useGeneralDetails = (
  id: string,
  options?: UseQueryOptions<General, DefaultError, General, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<General, DefaultError> => {
  return useQuery<General, DefaultError, General, QueryKey>(
    {
      queryKey: ["generalDrilldownData", id],
      enabled: false,
      queryFn: () => {
        return fetchDetails(id, `/api/generaldetails-values-id/${id}`);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useCircularDetails = (
  id: string,
  options?: UseQueryOptions<Circular, DefaultError, Circular, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Circular, DefaultError> => {
  return useQuery<Circular, DefaultError, Circular, QueryKey>(
    {
      queryKey: ["circularDrilldownData", id],
      enabled: false,
      queryFn: () => {
        return fetchDetails(id, `/api/circularviewdetails-id/${id}`);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCircularDetails, useGeneralDetails };
